import { B500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { ChevronDirection } from './types';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ControlsWrapper = styled.div({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ButtonWrapper = styled.div({
	width: '120px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	button: {
		userSelect: 'none',
	},
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const NavigationBulletsWrapper = styled.div({
	display: 'inherit',
	alignItems: 'inherit',
	justifyContent: 'center',
	maxWidth: '120px',
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
export const NavigationBullet = styled.div<{ isActive: boolean }>(({ isActive }) => ({
	width: '8px',
	height: '8px',
	backgroundColor: token('color.background.brand.bold', B500),
	borderRadius: '50%',
	cursor: 'pointer',
	margin: `0 ${token('space.050', '4px')}`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	opacity: isActive ? '1' : '0.4',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	':hover': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		opacity: isActive ? '1' : '0.6',
	},
}));

// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
export const ChevronWrapper = styled.div<{ direction: ChevronDirection }>`
	position: absolute;
	left: ${({ direction }) =>
		direction === ChevronDirection.LEFT ? token('space.300', '24px') : 'auto'};
	right: ${({ direction }) =>
		direction === ChevronDirection.RIGHT ? token('space.300', '24px') : 'auto'};
	top: 150px;
	opacity: 0.6;
	:hover {
		opacity: 1;
	}
	cursor: pointer;
	z-index: 1;
`;
